<template>
  <a
    v-if="(to || '').startsWith('http')"
    :href="to"
    target="_blank"
  >
    <slot />
  </a>
  <a
    v-else
    :href="resolveLocalePath(to)"
  >
    <slot />
  </a>
</template>

<script>
export default {

  props: {
    to: {
      type: [String, Object],
      default: '/',
    },
  },

  setup () {
    const { resolveLocalePath } = useUrlBuilder()

    return { resolveLocalePath }
  },
}
</script>

<style></style>
